import { render } from "./DadosStatPage.vue?vue&type=template&id=c3f237bc&scoped=true"
import script from "./DadosStatPage.vue?vue&type=script&lang=js"
export * from "./DadosStatPage.vue?vue&type=script&lang=js"

import "./DadosStatPage.vue?vue&type=style&index=0&id=c3f237bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f237bc"]])

export default __exports__